declare namespace $ {

	type $mol_text__text_shm_hitalama_settings_git_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_text['text'] >
	>
	type $shm_hitalama_settings_agent_password__input_name_shm_hitalama_settings_git_2 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_settings_agent_password['input_name'] >
	>
	type $shm_hitalama_settings_agent_password__value_shm_hitalama_settings_git_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_git['token'] >
		,
		ReturnType< $shm_hitalama_settings_agent_password['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_git_4 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_git_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_git['Token'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	type $mol_string__hint_shm_hitalama_settings_git_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_string['hint'] >
	>
	type $mol_string__value_shm_hitalama_settings_git_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_git['owner'] >
		,
		ReturnType< $mol_string['value'] >
	>
	type $mol_labeler__title_shm_hitalama_settings_git_8 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_labeler['title'] >
	>
	type $mol_labeler__Content_shm_hitalama_settings_git_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_settings_git['Owner'] >
		,
		ReturnType< $mol_labeler['Content'] >
	>
	export class $shm_hitalama_settings_git extends $mol_page {
		Hint( ): $mol_text
		token( next?: string ): string
		Token( ): $shm_hitalama_settings_agent_password
		Token_label( ): $mol_labeler
		owner( next?: string ): string
		Owner( ): $mol_string
		Owner_label( ): $mol_labeler
		title( ): string
		body( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=git.view.tree.d.ts.map